import {
    CLAN_SUPPLY_PROGRESSION_SETTINGS_REQUEST,
    CLAN_SUPPLY_PROGRESSION_SETTINGS_SUCCESS,
    CLAN_SUPPLY_PROGRESSION_SETTINGS_ERROR,
} from '../actions/clan_supply_progression_settings'

export const initialState = {
    errorMessage: null,
    loading: false,
    loaded: false,
    lastRequestTimestamp: null,
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case CLAN_SUPPLY_PROGRESSION_SETTINGS_REQUEST: {
        return {
            ...state,
            loading: true,
            errorMessage: null,
            lastRequestTimestamp: Date.now(),
        }
    }
    case CLAN_SUPPLY_PROGRESSION_SETTINGS_SUCCESS: {
        return {
            ...state,
            ...action.payload,
            loading: false,
            loaded: true,
            lastRequestTimestamp: Date.now(),
        }
    }
    case CLAN_SUPPLY_PROGRESSION_SETTINGS_ERROR: {
        return {
            ...state,
            loading: false,
            loaded: false,
            errorMessage: action.payload.errorMessage || action.payload.statusCode,
            lastRequestTimestamp: Date.now(),
        }
    }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/clan_supply_progression_settings.js